import { useEffect, useState } from 'react';
import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import useAutoFocus from '../../Utils/autoFocus';
import Select from 'react-select';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import '../../assets/css/Modal.css'; // Make sure to import the CSS
export const AddCourse = ({
    isOpen,
    orgform,
    handleChange,
    onClose,
    handleSubmit,
    handleUpdate,
    Updatebtn,
    masterdata,
    dnparentdata2,
    onCloseFee,
    specializationResponse,
    setorgform,
    setRefreshKey, handleSubjectChange, addSubjectRow, removeSubjectRow, isSubmitting, setIsSubmitting, duplicateSubjects
}) => {


    const nameInputRef = useAutoFocus(isOpen);
    const [step, setStep] = useState(1);
    useEffect(() => {
        if (isOpen) setStep(1);
    }, [isOpen]);




    useEffect(() => {
        const duration = parseInt(orgform.duration);
        const mode = orgform.mode?.toLowerCase();

        const modeMap = {
            annual: 12,
            semester: 6,
            trimester: 4,
            quarter: 3,
        };

        let count = '';

        if (!isNaN(duration) && duration > 0 && modeMap[mode]) {
            count = Math.ceil(duration / modeMap[mode]);
        }

        if (count && count.toString() !== orgform.mode_count) {
            handleChange({
                target: {
                    name: 'mode_count',
                    value: count.toString(),
                },
            });
        }
    }, [orgform.duration, orgform.mode]);

    if (!isOpen) return null;

    // Institution Options
    const institutionOptions = dnparentdata2?.map(item => ({
        value: item.id,
        label: item.name,
    })) || [];

    // Level Options
    const levelOptions = masterdata.master?.level?.map(item => ({
        value: item,
        label: item,
    })) || [];

    // Mode Options
    const modeOptions = masterdata.master?.mode?.map(item => ({
        value: item,
        label: item,
    })) || [];



    const semesterOptions = [
        { label: "Semester 1", value: "Semester 1" },
        { label: "Semester 2", value: "Semester 2" },
        { label: "Semester 3", value: "Semester 3" },
        { label: "Semester 4", value: "Semester 4" },
        { label: "Semester 5", value: "Semester 5" },
        { label: "Semester 6", value: "Semester 6" },
    ];
    const subjectTypeOptions = [
        { label: "Mandatory", value: "mandatory" },
        { label: "Optional", value: "optional" },
    ];
    const subjectNameOptions = [
        { label: "Mathematics", value: "Mathematics" },
        { label: "Physics", value: "Physics" },
        { label: "Chemistry", value: "Chemistry" },
        { label: "Computer Science", value: "Computer Science" },
        { label: "English", value: "English" },
    ];

    const subjects = Array.isArray(orgform?.subjects) ? orgform.subjects : [];

    // Count only subjects where a name is selected
    const totalSubjects = subjects.filter((s) => s.name).length;

    // Count unique semesters where semester is selected
    const totalSemesters = new Set(
        subjects
            .map((s) => s.semester)
            .filter(Boolean)
    ).size;

    if (!orgform) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content "
                style={{
                    position: "relative",
                    width: "55%",
                    height: "90vh",
                    display: "flex",
                    flexDirection: "column",
                    background: "#fff",
                }}>
                <div className="modal-header-content row" style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    background: "#fff",
                    padding: "12px 16px",
                    borderBottom: "1px solid #e5e5e5",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <div className='col-md-3'>  <h2 className="text-primary">{Updatebtn ? 'Update Course' : 'Add Course'}</h2></div>


                    <div className='col-md-9 d-flex justify-content-between  align-items-center '>
                        {/* Stepper */}
                        <div className="course-stepper">
                            {/* Step 1 */}
                            <div className={`step ${step >= 1 ? "active" : ""}`}>
                                <div
                                    className={`circle ${step > 1 ? "completed" : ""
                                        }`}
                                >
                                    {step > 1 ? "✓" : "1"}
                                </div>
                                <span>Course Details</span>
                            </div>

                            <div className={`line ${step > 1 ? "active" : ""}`} />

                            {/* Step 2 */}
                            <div className={`step ${step === 2 ? "active" : ""}`}>
                                <div className={`circle ${step === 2 ? "active" : ""}`}>
                                    {step > 2 ? "✓" : "2"}
                                </div>
                                <span>Subjects</span>
                            </div>
                        </div>

                        <button className="close-btn" onClick={() => {
                            if (onCloseFee) {
                                onCloseFee();   // 👈 Priority if coming from fee modal
                            } else if (onClose) {
                                onClose();      // 👈 Fallback if normal usage
                            }
                        }}
                        ><img src={close} alt="close" /></button>
                    </div>

                </div>



                <div className="modal-body recevingPaymentBody" style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "16px",
                }}>
                    {step === 1 && (<div className="row">
                        {/* Institution Select */}
                        <div className="col-md-12">
                            <label className="form-labell">Institution <span className="astrisk">*</span></label>
                            <Select
                                options={institutionOptions}
                                value={institutionOptions.find(opt => opt.value === orgform.organization_id) || null}
                                onChange={(selected) => handleChange({ target: { name: 'organization_id', value: selected?.value || '' } })}
                                placeholder="Select Institution"
                                classNamePrefix="react-select"
                                autoFocus
                                styles={reactSelectStyles}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuPosition="absolute" />
                        </div>
                        {/* Course Type (Regular / Back Paper) */}
                        <div className="col-md-12 mt-2">
                            <label className="form-labell">
                                Course Type <span className="astrisk">*</span>
                            </label>

                            <div className="d-flex gap-4 mt-1">
                                <label className="d-flex align-items-center gap-2">
                                    <input
                                        type="radio"
                                        name="course_type"
                                        value="regular"
                                        checked={orgform.course_type === "regular"}
                                        onChange={handleChange}
                                    />
                                    Regular
                                </label>

                                <label className="d-flex align-items-center gap-2">
                                    <input
                                        type="radio"
                                        name="course_type"
                                        value="back_paper"
                                        checked={orgform.course_type === "back_paper"}
                                        onChange={handleChange}
                                    />
                                    Back Paper
                                </label>
                            </div>
                        </div>
                        {/* Course Name */}
                        <div className="col-md-12">
                            <label className="form-labell">Course Name <span className="astrisk">*</span></label>
                            <input
                                type="text"
                                className="fm-modal form-control"
                                placeholder="Enter Course Name"
                                name="name"
                                value={orgform.name}
                                onChange={handleChange}

                            />
                        </div>

                        {/* Alias */}
                        <div className="col-md-12">
                            <label className="form-labell">Alias <span className="astrisk">*</span></label>
                            <input
                                type="text"
                                className="fm-modal form-control"
                                placeholder="Enter Alias"
                                name="alias"
                                value={orgform.alias}
                                onChange={handleChange}
                            />
                        </div>
                        {/* Level */}
                        <div className="col-md-12">
                            <label className="form-labell">Level <span className="astrisk">*</span></label>
                            <Select
                                autoFocus={false}
                                options={levelOptions}
                                value={levelOptions.find(opt => opt.value === orgform.level) || null}
                                onChange={(selected) => handleChange({ target: { name: 'level', value: selected?.value || '' } })}
                                placeholder="Select Level"
                                classNamePrefix="react-select"
                                styles={reactSelectStyles}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuPosition="absolute" />
                        </div>

                        {/* Duration */}
                        <div className="col-md-12">
                            <label className="form-labell">Course Duration (in months)<span className="astrisk">*</span></label>
                            <input
                                type="text"
                                className="fm-modal form-control"
                                placeholder="e.g., 12"
                                name="duration"
                                value={orgform.duration}
                                onChange={handleChange}
                            />
                        </div>
                        {/* Mode */}
                        <div className="col-md-12">
                            <label className="form-labell">Mode <span className="astrisk">*</span></label>
                            <Select
                                options={modeOptions}
                                value={modeOptions.find(opt => opt.value === orgform.mode) || null}
                                onChange={(selected) => handleChange({ target: { name: 'mode', value: selected?.value || '' } })}
                                placeholder="Select Mode"
                                classNamePrefix="react-select"
                                styles={reactSelectStyles}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuPosition="absolute" />
                        </div>







                    </div>)}
                    {/* Submit / Update Button */}

                    {step === 2 && (
                        <div className="row">
                            <div className="col-md-12">
                                <label className="form-labell">
                                    Subjects <span className="astrisk">*</span>
                                </label>

                                {Array.isArray(orgform?.subjects) && orgform.subjects.map((subject, index) => (
                                    <div
                                        key={index}
                                        className="row align-items-center mb-2"
                                    >
                                        {/* Subject Name */}
                                        <div className="col-md-4">
                                            <Select
                                                options={subjectNameOptions}
                                                value={
                                                    subjectNameOptions.find(
                                                        (opt) => opt.value === subject.name
                                                    ) || null
                                                }
                                                onChange={(selected) =>
                                                    handleSubjectChange(index, "name", selected?.value || "")
                                                }
                                                placeholder="Select Subject"
                                                styles={reactSelectStyles}
                                                menuPortalTarget={document.body}
                                                isClearable
                                            />
                                        </div>

                                        {/* Semester Dropdown */}
                                        <div className="col-md-4">
                                            <Select
                                                options={semesterOptions}
                                                value={
                                                    semesterOptions.find(
                                                        (opt) => opt.value === subject.semester
                                                    ) || null
                                                }
                                                onChange={(selected) =>
                                                    handleSubjectChange(
                                                        index,
                                                        "semester",
                                                        selected?.value || ""
                                                    )
                                                }
                                                placeholder="Semester"
                                                styles={reactSelectStyles}
                                                menuPortalTarget={document.body}
                                                isClearable
                                            />
                                        </div>

                                        {/* Mandatory / Optional */}
                                        <div className="col-md-3">
                                            <Select
                                                options={subjectTypeOptions}
                                                value={
                                                    subjectTypeOptions.find(
                                                        (opt) => opt.value === subject.type
                                                    ) || null
                                                }
                                                onChange={(selected) =>
                                                    handleSubjectChange(
                                                        index,
                                                        "type",
                                                        selected?.value || ""
                                                    )
                                                }
                                                placeholder="Type"
                                                isClearable
                                                styles={reactSelectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>

                                        {/* Remove */}
                                        <div className="col-md-1">
                                            {orgform.subjects.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeSubjectRow(index)}
                                                    className="btn  text-danger"
                                                    title="Remove Subject"
                                                >
                                                    ✕
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    onClick={addSubjectRow}
                                    style={{
                                        border: "none",
                                        background: "none",
                                        color: "#7F56DA",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                    }}
                                >
                                    + Add Subject
                                </button>
                            </div>
                            {/* <div className="d-flex gap-2 mt-3">
                                <span
                                    style={{
                                        background: "#EEF2FF",
                                        color: "#4F46E5",
                                        padding: "4px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                    }}
                                >
                                    Total Subjects: {totalSubjects}
                                </span>

                                <span
                                    style={{
                                        background: "#ECFDF5",
                                        color: "#15803D",
                                        padding: "4px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                    }}
                                >
                                    Total Semesters: {totalSemesters}
                                </span>
                            </div> */}

                        </div>
                    )}
                </div>
                <div
                    className="row mt-4"
                    style={{
                        position: "sticky",
                        bottom: 0,
                        zIndex: 10,
                        background: "#fff",
                        padding: "12px 16px",
                        borderTop: "1px solid #e5e5e5",
                    }}
                >
                    <div className="col-md-12 d-flex align-items-center justify-content-between">

                        {/* LEFT SIDE – Mode Count (only Step 1) */}
                        <div>
                            {step === 1 && orgform.mode && orgform.duration && orgform.mode_count && (
                                <div className="d-flex align-items-center gap-2" style={{ fontWeight: 500 }}>
                                    <span>{orgform.mode} Count:</span>
                                    <span>
                                        {orgform.mode_count} {orgform.mode}
                                        {orgform.mode_count > 1 ? "s" : ""}
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* RIGHT SIDE – Buttons (always right aligned) */}
                        <div className="d-flex gap-2">
                            {step === 2 && (
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => setStep(1)}
                                >
                                    Back
                                </button>
                            )}

                            {step === 1 && (
                                <button className="add-btn" onClick={() => setStep(2)}>
                                    Next
                                    <img src={next} className="ms-2" alt="next" />
                                </button>
                            )}

                            {step === 2 && (
                                <button
                                    className="add-btn"
                                    onClick={Updatebtn ? handleUpdate : handleSubmit}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <span className="spinner-border spinner-border-sm" />
                                    ) : (
                                        <>
                                            {Updatebtn ? "Update Course" : "Add Course"}
                                            <img src={next} className="ms-2" alt="next" />
                                        </>
                                    )}
                                </button>
                            )}
                        </div>

                    </div>
                </div>



            </div>
        </div>
    );
};
